import React, {Component} from 'react';
import {Field} from 'redux-form';
import * as Form from './formFieldHelpers';
import * as Date from '../dates/dateHelpers';
import * as Buttons from '../ui/buttons';
import DateRange from '../dates/dateRange';

export default class EducationForm extends Component {
    componentDidMount() {
        this.handleInitialise();
    }

    handleInitialise = () => {
        const {initialize, personId, id, institution, qualification, qualification_date, description, person_id, data} = this.props;
      const qualificationMonth = qualification_date !== 'Present' || undefined || null ? Date.handleDates(qualification_date).startMonth : qualification_date;
      const qualificationYear = qualification_date !== 'Present' || undefined || null ? Date.handleDates(qualification_date).startYear : qualification_date;

        const initialValues = {
            "person_id": ( data && data.personId ) || +personId || +person_id,
            "id": id,
            "type": id ? "UPDATE" : "CREATE",
            "i_still_study_here": ( qualification_date === 'Present' ),
            "institution": institution,
            "qualification": qualification,
            "end_month": (qualification_date !== 'Present' || undefined || null) ? {label: qualificationMonth && qualificationMonth.name, value: qualificationMonth && qualificationMonth.id} : "",
            "end_year": (qualification_date !== 'Present' || undefined || null) ? {label: qualificationYear && qualificationYear, value: qualificationYear} : "",
            "description": description,
        };
        initialize( initialValues );
    };

    render() {
        const { buttonHandlers, qualification_date, onCancel, institution, handleAdding } = this.props,
                numberButtons = institution && 3;
        const typeOfReq = this.props.id ? "UPDATE" : "CREATE";

        return (
            <div>
                <form className="form-standard-profile">
                    <div className="row">
                        <div className="col-xs-12">
                            <Field
                                label="Institution"
                                name="institution"
                                placeholder="Institution"
                                component={ Form.textField }
                            />
                        </div>
                        <div className="col-xs-12 col-md-6">
                            <Field
                                label="Qualification"
                                name="qualification"
                                placeholder="Qualification"
                                component={ Form.textField }
                            />
                        </div>

                        <DateRange type={typeOfReq} typeOf="study" qualification_date={qualification_date} noEndDate={ true }/>

                        <div className="col-xs-12">
                            <Field
                                label="Description"
                                name="description"
                                placeholder="Description."
                                component={ Form.quill }
                            />
                        </div>
                        <div className="col-xs-12">
                            <Field
                                name="errors_on_form"
                                component={ Form.errorField }
                                hidden
                            />
                        </div>
                    </div>
                    <Buttons.HOCFormButtons
                        { ... this.props }
                        onCancel={ () => onCancel () }
                        handleAdding={ ( form ) => handleAdding ( form ) }
                        { ...buttonHandlers }
                        numberButtons={ numberButtons }
                    />
                </form>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/forms/EducationForm.js